export enum TranslatorApiVersionEnum {
  Current = "CURRENT",
  Explainer = "EXPLAINER",
}
